import React from 'react'
import { Calendar1 } from 'iconsax-react'
import CommonButton from '../CommonButton'
import Calendar from '@SonarCX/components/atoms/Calendar'

import { formatDateRelative } from '@SonarCX/utilities'
import useTaskMultiEdit from '../hooks/useTaskMultiEdit'
import useStyles from '../commonStyles'

const SetDueDate: React.FC = () => {
  const calenderRef = React.useRef()

  const { selected, patchTasks } = useTaskMultiEdit()

  const [value, setValue] = React.useState(new Date())

  const classes = useStyles()

  const handleClose = React.useCallback(() => {
    setValue(new Date())
  }, [])

  const handleAccept = React.useCallback(async () => {
    const updates: TaskPatch[] = selected.map(id => ({
      id,
      due_date: value.toISOString()
    }))
    await patchTasks({ updates, message: 'Due date updated' })
    handleClose()
  }, [selected, value, patchTasks, handleClose])

  return (
    <CommonButton
      title='Set due date'
      Icon={Calendar1}
      onAccept={handleAccept}
      onClose={handleClose}
    >
      <div className={classes.content}>
        <div className={classes.title}>Due Date</div>

        <div className={classes.center} ref={calenderRef}>
          {/* @ts-expect-error Prop types incorrect */}
          <Calendar
            value={value}
            onChange={val => setValue(val.toDate())}
            anchorEl={calenderRef}
          >
            {formatDateRelative(value, true)}
          </Calendar>
        </div>
      </div>
    </CommonButton>
  )
}

export default SetDueDate
